/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CommunicationsSocketSubscribeAck = {
    type: CommunicationsSocketSubscribeAck.type;
    payload: {
        action: CommunicationsSocketSubscribeAck.action;
        authorizationGeneration: CommunicationsSocketSubscribeAck.authorizationGeneration;
        count: number;
        requestedTopics: Array<string>;
        topics: Array<string>;
    };
};
export namespace CommunicationsSocketSubscribeAck {
    export enum type {
        ACK = 'ack',
    }
    export enum action {
        SUBSCRIBE = 'subscribe',
    }
    export enum authorizationGeneration {
        '_1' = 1,
    }
}

